import React, { useEffect, useState } from "react";
import api from "../../../utils/Url";
import Card from "@mui/material/Card";
import {
  Box,
  Divider,
  Grid,
  Typography,
  Autocomplete,
  TextField,
  Button,
} from "@mui/material";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getId } from "../../../utils/Constant";
import CustomLabel from "../../../CustomLable";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function EditItemMaster() {
  const { t } = useTranslation();
  const Userid = getId();
  let navigate = useNavigate();
  const location = useLocation();
  const [lang, setLang] = useState<Language>("en");
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });
  const [option, setOption] = useState<any>([{ value: "-1", label: t("text.selectitemTypeId") }]);
  const [brandOptions, setBrandOptions] = useState<any>([{ value: "-1", label: t("text.BrandNames") }]);
  const [taxOptions, setTaxOptions] = useState<any>([]);
  const [employeeOptions, setemployeeOptions] = useState<any>([]);
  const [itemCategoryOptions, setitemCategoryOptions] = useState<any>([]);
  const [unitOptions, setUnitOptions] = useState<any>([]);
  const [itemgroupOptions, setitemgroupOptions] = useState<any>([{ value: "-1", label: t("text.selectGroup") }]);

  const [IsPole, setPole] = useState<any>(true);
  const [IsLight, setLight] = useState<any>(true);
  const [IsMaterial, setMaterial] = useState<any>(true);


  const [countryOptions, setCountryOptions] = useState<any>([]);

  const [warrOptions, setWarrOptions] = useState<any>([{ value: "-1", label: t("text.SelectWarranty") }]);

  const [hsnOptions, setHsnOptions] = useState<any>([{ value: "-1", label: t("text.SelectHSN") }]);

  useEffect(() => {
    GetitemCategoryData();
    GetEmployeeData();
    // fetchZonesData();
    GetItemTypeData();
    GetTaxData();
    GetBrandData();
    GetUnitData();
    GetItemGroupData();
    countryData();


    if (location.state.itemGroupId === 16) {
      setPole(false);
      setLight(true);
      setMaterial(true);
    } else if (location.state.itemGroupId === 15) {
      setMaterial(false);
      setLight(true);
      setPole(true);
    } else if (location.state.itemGroupId === 14) {
      setLight(false);
      setPole(true);
      setMaterial(true);
    } else {

      setLight(true);
      setPole(true);
      setMaterial(true);

    }


    warrantyData();
    hsnData();

  }, []);
  // }, [isLoading]);  SelectEmployeeName

  const warrantyData = async () => {
    const collectData = {
      "id": -1,
    };
    const response = await api.post(`WarrantyPeriodMaster/GetWarrantyMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["warrantyName"],
        value: data[index]["id"],
      });
    }
    setWarrOptions(arr);
  };


  const hsnData = async () => {
    const collectData = {
      "id": -1,
    };
    const response = await api.post(`HSNMaster/GetHSNMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["hsnName"],
        value: data[index]["id"],
      });
    }
    setHsnOptions(arr);
  };


  const countryData = async () => {
    const collectData = {
      "countryId": -1,
    };
    const response = await api.post(`Country/GetCountryMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["countryName"],
        value: data[index]["countryId"],
      });
    }
    setCountryOptions([{ value: "-1", label: t("text.SelectCountry") }, ...arr]);
  };

  const GetEmployeeData = async () => {
    const collectData = {
      "empid": -1,
      "userId": "",
      "empName": "",
      "empMobileNo": "",
      "empDesignationId": -1,
      "empDeptId": -1,
      "empStateId": -1,
      "empCountryID": -1,
      "empCityId": -1,
      "empPincode": 0,
      "roleId": ""
    };
    const response = await api.post(`EmpMaster/GetEmpmaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["empName"],
        value: data[index]["empid"],
      });
    }
    setemployeeOptions([{ value: "-1", label: t("text.SelectEmployeeName") }, ...arr]);
  }
  const GetItemGroupData = async () => {
    const collectData = {
      groupid: -1,
    };
    const response = await api.post(`ItemGroup/GetItemGroup`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["group_name"],
        value: data[index]["groupid"],
      });
    }
    setitemgroupOptions(arr);
  };

  const GetItemTypeData = async () => {
    const collectData = {
      itemTypeMasterId: -1,
    };
    const response = await api.post(`ItemType/GetItemTypeMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["itemType"],
        value: data[index]["itemTypeMasterId"],
      });
    }
    setOption(arr);
  };


  const GetitemCategoryData = async () => {
    const collectData = {
      itemCategoryId: -1,
    };
    const response = await api.post(`ItemCategory/GetItemCategoryMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["itemCategory"],
        value: data[index]["itemCategoryId"],
      });
    }
    setitemCategoryOptions([{ value: "-1", label: t("text.selectItemCategory") }, ...arr]);
  };

  const handleConversionChange = (params: any, text: string) => {
    formik.setFieldValue(params, text);
  };


  const GetTaxData = async () => {
    const collectData = {
      taxId: -1,
    };
    const response = await api.post(`TaxMaster/GetTaxMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["taxName"],
        value: data[index]["taxId"],
      });
    }
    setTaxOptions([{ value: "-1", label: t("text.tax") }, ...arr]);
  };

  const GetBrandData = async () => {
    const collectData = {
      brandID: -1,
    };
    const response = await api.post(`BrandMaster/GetBrandmaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["brandName"],
        value: data[index]["brandID"],
      });
    }
    setBrandOptions([{ value: "-1", label: t("text.brandName") }, ...arr]);
  };



  const GetUnitData = async () => {
    const collectData = {
      unitId: -1,
    };
    const response = await api.post(`UnitMaster/GetUnitMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["unitName"],
        value: data[index]["unitId"],
      });
    }
    setUnitOptions([{ value: "-1", label: t("text.selectUnit") }, ...arr]);
  };




  const validationSchema = Yup.object().shape({
    itemName: Yup.string()
      .required(t("text.itemNameRequired"))
      .min(2, t("text.itemNameMin"))
      .max(100, t("text.itemNameMax")),
    itemCategoryId: Yup.string()
      .required(t("Item Category is required")),
    itemTypeId: Yup.string()
      .required(t("Item Type is required")),
    taxId: Yup.string()
      .required(t("Tax is required")),
    unitId: Yup.string()
      .required(t("Unit is required")),

    depreciationRate: Yup.string()
      .required(t("Depreciation Rate is required")),
    itemGroupId: Yup.string()
      .required(t("Item Group is required")),

  });

  const formik = useFormik({
    initialValues: {
      itemMasterId: location.state.itemMasterId,
      itemName: location.state.itemName,
      itemCode: location.state.itemCode,
      itemCategoryId: location.state.itemCategoryId,
      itemFlag: location.state.itemFlag,
      itemTypeId: location.state.itemTypeId,
      empId: location.state.empId,
      taxId: location.state.taxId,
      brandID: location.state.brandID,
      purchaseYear: location.state.purchaseYear,
      unitId: location.state.unitId,
      serialNo: String(location.state.serialNo),
      vehicleNo: location.state.vehicleNo,
      qcApplicable: true,
      hsnCode: location.state.hsnCode,
      itemWeight: location.state.itemWeight,
      depreciationRate: location.state.depreciationRate,
      createdBy: Userid,
      updatedBy: Userid,
      createdOn: new Date().toISOString(),
      updatedOn: new Date().toISOString(),
      itemGroupId: location.state.itemGroupId,
      watt: location.state.watt,
      volt: location.state.volt,
      wire: location.state.wire,
      wight: location.state.wight,
      itemColor: location.state.itemColor,
      itemImg: location.state.itemImg,
      powerSource: location.state.powerSource,
      genericName: location.state.genericName,
      manufacture: location.state.manufacture,
      itemDimention: location.state.itemDimention,
      underGroundPoleHight: location.state.underGroundPoleHight,
      num_Of_Light_Attach: location.state.num_Of_Light_Attach,
      currentStatus: location.state.currentStatus,
      countryOfOrigen: location.state.countryOfOrigen,
      rate: location.state.rate,
      itemStatus: location.state.itemStatus,
      qc: true,

      "countryId": location.state.countryId,
      "countryName": location.state.countryName,
      "warrantyId": location.state.warrantyId,
      "warrantyName": location.state.warrantyName,
      "hsnId": location.state.hsnId,
      "hsnName": location.state.hsnName,
    },

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const response = await api.post("ItemMaster/AddUpdateItemMaster", values);
      if (response.data.isSuccess) {
        formik.resetForm();
        // fetchZonesData();
        setTimeout(() => {

          toast.success(response.data.mesg);
        }, 200);
        navigate("/master/ItemMasters")
        // setEditId(-1);
      } else {
        toast.error(response.data.mesg);
      }
    },
  });

  const back = useNavigate();

  return (
    <>
      <Card
        style={{
          width: "100%",
          backgroundColor: "lightgreen",
          border: ".5px solid #2B4593",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            // backgroundColor:"lightseagreen"
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Grid item xs={12} container spacing={2}>
            <Grid item lg={2} md={2} xs={2} marginTop={2}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  backgroundColor: "blue",
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Grid>
            <Grid item lg={7} md={7} xs={7} alignItems="center" justifyContent="center">
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ padding: "20px" }}
                align="center"
              >
                {t("text.edititemMaset")}
              </Typography>
            </Grid>

            <Grid item lg={3} md={3} xs={3} marginTop={3}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l: any) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>

          <Divider />

          <Box height={10} />
          <form onSubmit={formik.handleSubmit}>
            {/* <Grid container spacing={2}> */}
            {/* First Row */}
            <Grid container item xs={12} spacing={2}>
              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.enteritemName")}
                  value={formik.values.itemName}
                  onChangeText={(text) => handleConversionChange("itemName", text)}
                  required={true}
                  lang={lang}
                />
                {formik.touched.itemName && formik.errors.itemName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.itemName)}
                  </div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.enteritemCode")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="itemCode"
                  id="itemCode"
                  value={formik.values.itemCode}
                  placeholder={t("text.enteritemCode")}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={itemgroupOptions}
                  value={
                    itemgroupOptions.find(
                      (option: any) => option.value === formik.values.itemGroupId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("itemGroupId", newValue?.value);
                    if (newValue?.value === 16) {
                      setPole(false);
                      setLight(true);
                      setMaterial(true);
                    } else if (newValue?.value === 15) {
                      setMaterial(false);
                      setLight(true);
                      setPole(true);
                    } else if (newValue?.value === 14) {
                      setLight(false);
                      setPole(true);
                      setMaterial(true);
                    } else {

                      setLight(true);
                      setPole(true);
                      setMaterial(true);

                    }

                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.selectGroup")}
                          required={true}
                          value={formik.values.itemCategoryId}
                        />
                      }
                    />
                  )}
                />
                {formik.touched.itemGroupId && formik.errors.itemGroupId ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.itemGroupId)}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={itemCategoryOptions}
                  value={
                    itemCategoryOptions.find(
                      (option: any) => option.value === formik.values.itemCategoryId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("itemCategoryId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.selectItemCategory")}
                          required={true}
                          value={formik.values.itemCategoryId}
                        />
                      }
                    />
                  )}
                />
                {formik.touched.itemCategoryId && formik.errors.itemCategoryId ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.itemCategoryId)}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={option}
                  value={
                    option.find(
                      (option: any) => option.value === formik.values.itemTypeId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("itemTypeId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.selectitemTypeId")}
                          required={true}
                          value={formik.values.itemTypeId}
                        />
                      }
                    />
                  )}
                />
                {formik.touched.itemTypeId && formik.errors.itemTypeId ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.itemTypeId)}
                  </div>
                ) : null}
              </Grid>


              {/* <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={employeeOptions}
                  fullWidth
                  size="small"
                  onChange={(event, newValue:any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("empId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.SelectEmployeeName")}
                        />
                      }
                    />
                  )}
                />

              </Grid> */}
              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={unitOptions}
                  value={
                    unitOptions.find(
                      (option: any) => option.value === formik.values.unitId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("unitId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.selectUnit")}
                          required={true}
                          value={formik.values.unitId}
                        />
                      }
                    />
                  )}
                />
                {formik.touched.unitId && formik.errors.unitId ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.unitId)}
                  </div>
                ) : null}
              </Grid>



              {/* <Grid item xs={12} sm={4} lg={4}>
              <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={itemCategoryOptions}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("itemCategoryId", newValue?.value);
                  }}
                  value={
                    itemCategoryOptions.find(
                      (opt) => opt.value === formik.values.itemCategoryId
                    ) || null
                  }
                  // value={}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.itemCategory")}
                        />
                      }
                    />
                  )}
                />
              </Grid> */}


              {/* <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.enterpurchaseYear")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="purchaseYear"
                  id="purchaseYear"
                  value={formik.values.purchaseYear}
                  placeholder={t("text.enterpurchaseYear")}
                  onChange={formik.handleChange}
                />
              </Grid> */}


              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.enterserialNo")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  type="text"
                  name="serialNo"
                  id="serialNo"
                  value={formik.values.serialNo}
                  placeholder={t("text.enterserialNo")}
                  onChange={formik.handleChange}
                />
              </Grid>

              {/* <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.entervehicleNo")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="vehicleNo"
                  id="vehicleNo"
                  value={formik.values.vehicleNo}
                  placeholder={t("text.entervehicleNo")}
                  onChange={formik.handleChange}
                />
              </Grid> */}

<Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={hsnOptions}
                  fullWidth

                  value={
                    hsnOptions.find(
                      (option: any) => option.value === formik.values.hsnId
                    ) || null
                  }
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("hsnId", newValue?.value);
                    formik.setFieldValue("hsnName", newValue?.label);

                    
                    
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.SelectHSN")}
                          required={false}
                          //value={formik.values.unitId}
                        />
                      }
                    />
                  )}
                />
                
              </Grid>


              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={warrOptions}
                  value={
                    warrOptions.find(
                      (option: any) => option.value === formik.values.warrantyId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("warrantyId", newValue?.value);
                    formik.setFieldValue("warrantyName", newValue?.label);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.SelectWarranty")}
                          required={false}
                         // value={formik.values.unitId}
                        />
                      }
                    />
                  )}
                />
               
              </Grid>


              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.Rate")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="rate"
                  id="rate"
                  value={formik.values.rate}
                  placeholder={t("text.Rate")}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={brandOptions}
                  value={
                    brandOptions.find(
                      (option: any) => option.value === formik.values.brandID
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("brandID", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.brandname")}
                          required={true}
                          value={formik.values.brandID}
                        />
                      }
                    />
                  )}
                />
                {formik.touched.brandID && formik.errors.brandID ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.brandID)}
                  </div>
                ) : null}
              </Grid>

              {/* <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.enterweight")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="wight"
                  id="wight"
                  value={formik.values.wight}
                  placeholder={t("text.enterweight")}
                  onChange={formik.handleChange}
                />
              </Grid> */}

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.enterdepreciationRate")}
                      required={true}
                    //value={formik.values.depreciationRate}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="depreciationRate"
                  id="depreciationRate"
                  value={formik.values.depreciationRate}
                  placeholder={t("text.enterdepreciationRate")}
                  onChange={(e) => formik.setFieldValue("depreciationRate", Number(e.target.value))}
                />
                {formik.touched.depreciationRate && formik.errors.depreciationRate ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.depreciationRate)}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={taxOptions}
                  value={
                    taxOptions.find(
                      (option: any) => option.value === formik.values.taxId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("taxId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.tax")}
                          required={true}
                          value={formik.values.taxId}
                        />
                      }
                    />
                  )}
                />
                {formik.touched.taxId && formik.errors.taxId ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.taxId)}
                  </div>
                ) : null}
              </Grid>





              {IsLight && (
                <Grid item xs={12} sm={4} lg={4}>
                  <TextField
                    label={
                      <CustomLabel
                        text={t("text.enteritemWeight")}
                        required={false}
                      // value={formik.values.itemWeight}
                      />
                    }
                    variant="outlined"
                    fullWidth
                    size="small"
                    name="itemWeight"
                    id="itemWeight"
                    value={formik.values.itemWeight}
                    placeholder={t("text.enteritemWeight")}
                    onChange={(e:any) => {
                      formik.setFieldValue('itemWeight', parseInt(e.target.value))
                    }}

                  />

                </Grid>

              )}

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={countryOptions}

                  value={countryOptions.find((opt: any) => opt.value === formik.values.countryId) || null}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("countryOfOrigen", newValue?.label);
                    formik.setFieldValue("countryId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.SelectCountry")}
                          required={false}
                        //value={formik.values.itemCategoryId}
                        />
                      }
                    />
                  )}
                />

              </Grid>



              {IsMaterial && (
                <>

                  {IsPole && (
                    <>

                      <Grid item xs={12} sm={4} lg={4}>
                        <TextField
                          label={
                            <CustomLabel
                              text={t("text.enterwatt")}
                              required={false}
                            />
                          }
                          variant="outlined"
                          fullWidth
                          size="small"
                          name="watt"
                          id="watt"
                          value={formik.values.watt}
                          placeholder={t("text.enterwatt")}
                          onChange={formik.handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <TextField
                          label={
                            <CustomLabel
                              text={t("text.entervolt")}
                              required={false}
                            />
                          }
                          variant="outlined"
                          fullWidth
                          size="small"
                          name="volt"
                          id="volt"
                          value={formik.values.volt}
                          placeholder={t("text.entervolt")}
                          onChange={formik.handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <TextField
                          label={
                            <CustomLabel
                              text={t("text.enterwire")}
                              required={false}
                            />
                          }
                          variant="outlined"
                          fullWidth
                          size="small"
                          name="wire"
                          id="wire"
                          value={formik.values.wire}
                          placeholder={t("text.enterwire")}
                          onChange={formik.handleChange}
                        />
                      </Grid>



                      <Grid item xs={12} sm={4} lg={4}>
                        <TextField
                          label={
                            <CustomLabel
                              text={t("text.enterpowerSource")}
                              required={false}
                            />
                          }
                          variant="outlined"
                          fullWidth
                          size="small"
                          name="powerSource"
                          id="powerSource"
                          value={formik.values.powerSource}
                          placeholder={t("text.enterpowerSource")}
                          onChange={formik.handleChange}
                        />
                      </Grid>

                    </>
                  )}


                  <Grid item xs={12} sm={4} lg={4}>
                    <TextField
                      label={
                        <CustomLabel
                          text={t("text.enteritemColor")}
                          required={false}
                        />
                      }
                      variant="outlined"
                      fullWidth
                      size="small"
                      name="itemColor"
                      id="itemColor"
                      value={formik.values.itemColor}
                      placeholder={t("text.enteritemColor")}
                      onChange={formik.handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} lg={4}>
                    <TextField
                      label={
                        <CustomLabel
                          text={t("text.entergenericName")}
                          required={false}
                        />
                      }
                      variant="outlined"
                      fullWidth
                      size="small"
                      name="genericName"
                      id="genericName"
                      value={formik.values.genericName}
                      placeholder={t("text.entergenericName")}
                      onChange={formik.handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} lg={4}>
                    <TextField
                      label={
                        <CustomLabel
                          text={t("text.entermanufacture")}
                          required={false}
                        />
                      }
                      variant="outlined"
                      fullWidth
                      size="small"
                      name="manufacture"
                      id="manufacture"
                      value={formik.values.manufacture}
                      placeholder={t("text.entermanufacture")}
                      onChange={formik.handleChange}
                    />
                  </Grid>

                  {IsLight && (
                    <>
                      <Grid item xs={12} sm={4} lg={4}>
                        <TextField
                          label={
                            <CustomLabel
                              text={t("text.enteritemDimention")}
                              required={false}
                            />
                          }
                          variant="outlined"
                          fullWidth
                          size="small"
                          name="itemDimention"
                          id="itemDimention"
                          value={formik.values.itemDimention}
                          placeholder={t("text.enteritemDimention")}
                          onChange={formik.handleChange}
                        />
                      </Grid>




                      <Grid item xs={12} sm={4} lg={4}>
                        <TextField
                          label={
                            <CustomLabel
                              text={t("text.enterunderGroundPoleHight")}
                              required={false}
                            />
                          }
                          variant="outlined"
                          fullWidth
                          size="small"
                          name="underGroundPoleHight"
                          id="underGroundPoleHight"
                          value={formik.values.underGroundPoleHight}
                          placeholder={t("text.enterunderGroundPoleHight")}
                          onChange={formik.handleChange}
                        />
                      </Grid>
                    </>

                  )}

                  <Grid item xs={12} sm={4} lg={4}>
                    <TextField
                      label={
                        <CustomLabel
                          text={t("text.enternum_Of_Light_Attach")}
                          required={false}
                        />
                      }
                      variant="outlined"
                      fullWidth
                      size="small"
                      name="num_Of_Light_Attach"
                      id="num_Of_Light_Attach"
                      value={formik.values.num_Of_Light_Attach}
                      placeholder={t("text.enternum_Of_Light_Attach")}
                      onChange={formik.handleChange}
                    />
                  </Grid>
                </>
              )}


              <Grid item sm={8} md={8} lg={8}>

              </Grid>



              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  {t("text.update")}
                </Button>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>

          {/* {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <CustomDataGrid
              isLoading={isLoading}
              rows={zones}
              columns={adjustedColumns}
              pageSizeOptions={[5, 10, 25, 50, 100]}
              initialPageSize={5}
            />
          )} */}
        </Paper>
      </Card>
      <ToastApp />
    </>
  );
};